// extracted by mini-css-extract-plugin
export default {"cls1":"AttachmentOverlay-cls1_qjg","cls2":"AttachmentOverlay-cls2_MIi AttachmentOverlay-cls1_qjg"};